function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="14" height="21" viewBox="0 0 14 21" {...props}><path d="M6.467 2.592a3.89 3.89 0 0 1 3.881 3.891A3.83 3.83 0 0 1 8.813 9.57c-1.46 1.104-2.05 2.324-2.253 3.35h-.185c-.202-1.026-.794-2.246-2.253-3.35a3.836 3.836 0 0 1-1.536-3.087 3.89 3.89 0 0 1 3.881-3.89zm0-2.592C2.895 0 0 2.903 0 6.482c0 2.123 1 3.977 2.567 5.16.721.545 1.316 1.248 1.316 2.218v1.652h5.17V13.86c0-.97.595-1.673 1.315-2.219a6.41 6.41 0 0 0 2.567-5.159C12.935 2.902 10.039 0 6.467 0zM3.88 18.109h5.174v2.587H3.88v-2.587z" /></svg>;
});